import { getTenant } from './cloudLocationUtils';
import { getEnvVar } from './getEnvVar';

function mapLocation(location: Location | string) {
    if (typeof location === 'object') {
        return window.location.origin + location.pathname + location.search;
    }

    return location;
}

export function combineQueryParams(params: URLSearchParams, url: string) {
    if (typeof url === 'string') {
        const returnSearchIndex = url.indexOf('?');
        if (returnSearchIndex !== -1) {
            const returnQueryParams = new URLSearchParams(url.substring(returnSearchIndex + 1));

            returnQueryParams.forEach((value, key) => {
                params.set(key, value);
            });
        }
    }
}

export function redirectToSSO(
    location: Parameters<typeof mapLocation>['0'],
    path: string,
    hash = '',
    forceTenant: boolean | null | undefined = undefined,
) {
    const urlTenant = forceTenant ?? getTenant();
    const returnUrl = mapLocation(location);

    const params = {
        product: 'CVPN',
        tenant: urlTenant === 'cloud' ? undefined : urlTenant,
        return: encodeURIComponent(returnUrl),
    };

    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined) {
            searchParams.append(key, value as string);
        }
    }

    combineQueryParams(searchParams, returnUrl);

    return `${getEnvVar('SSO_HOST')}/${path}?${searchParams.toString()}${hash}`;
}
